import { Button, Col, Form, List, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { complexDigitToman } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import { NotFound } from "../../../../sources/svg/svg";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import { switchPlanID } from "../../../../tools/services";

const Packages = ({ categoryList = [], packagesList = [], msisdn, purchase = null }) => {
	const { queryPackagesBySubGroup } = useDealer();
	const [packages, setPackages] = useState([]);
	const [categories, setCategories] = useState([]);
	const [chooseOption, setChooseOption] = useState();
	const [isLoading, setIsLoading] = useState(false);

	const nav = useNavigate();

	useEffect(() => {
		setPackages(packagesList);
		setCategories(categoryList);
	}, [packagesList]);

	const handleChange = async (value, option) => {
		setIsLoading(true);
		setChooseOption(value);
		let payload = {
			subproductgroupid: value,
			planid: switchPlanID().extraPackage,
		};
		let response = await queryPackagesBySubGroup(payload);
		if (response) {
			setPackages(response);
		}
		setIsLoading(false);
	};
	const switchSpecialType = (keyVal, specialKey) => {
		if (keyVal === 1) {
			return <span className="internet">بسته اینترنت</span>;
		}
		if (keyVal === 2) {
			return <span className="combo">بسته ترکیبی</span>;
		}
		if (specialKey === 2) {
			return <span className="roaming">رومینگ عراق</span>;
		}
		if (specialKey === 1) {
			return <span className="roaming">رومینگ ترکیه</span>;
		}
	};
	const handleChoosePackage = (selectPackage) => {
		nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.PreFactor, {
			state: {
				package: selectPackage,
				msisdn: msisdn,
				purchase: purchase,
			},
		});
	};
	return (
		<>
			<div className="packages-list-show">
				<h3>لطفا بسته مورد نظر را انتخاب کنید</h3>
				<div className="show-type-filter">
					<Form layout="vertical">
						<Row gutter={16}>
							{categories.map((item, key) => (
								<Col span={4} xl={4} lg={6} md={6} sm={12} xs={12} key={key}>
									<Form.Item className="input-normal" label={item.productGroupName}>
										<Select
											placeholder={item.productGroupName}
											onChange={handleChange}
											value={item.subgroup.filter((sitem) => sitem.inT_ProductSubGroupId === chooseOption)?.length > 0 ? chooseOption : ""}>
											{item.subgroup.map((sItem, sKey) => (
												<Select.Option key={sKey} value={sItem.inT_ProductSubGroupId} category={item.productGroupId}>
													{sItem.stR_ProductSubGroupName}
												</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
							))}
						</Row>
					</Form>
				</div>
				<div className="show-packages">
					<List
						itemLayout="horizontal"
						dataSource={packages}
						loading={isLoading}
						locale={{ emptyText: <NotFound text={""} /> }}
						renderItem={(item, key) => (
							<div className="item" key={key}>
								<div className="row-item">
									<div className="hold-tag">{switchSpecialType(item.packageType, item.specialPackageType)}</div>
									<div className="hold-title">
										<h3>{item.packageName}</h3>
										<p>
											{item.voiceCallInDoorDescription !== "0 دقیقه" && (
												<>
													{item.voiceCallInDoorDescription}
													{item.packageType === 12 ? <> مکالمه با خطوط ترکیه</> : <> مکالمه آپتلی و غیرآپتلی</>}{" "}
												</>
											)}
											{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
												<>
													+{item.smsDescription}
													{item.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}{" "}
												</>
											)}
										</p>
									</div>
									<div className="hold-type">{item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</div>
									<div className="hold-price">
										<span dir="ltr">{complexDigitToman(item.packagePrice)}</span> تومان
									</div>
									<div className="hold-button">
										<Button htmlType="button" data-object={JSON.stringify(item)} onClick={() => handleChoosePackage(item)}>
											انتخاب
										</Button>
									</div>
								</div>
							</div>
						)}
					/>
				</div>
			</div>
		</>
	);
};

export default Packages;
